module.exports = __webpack_public_path__ + "static/media/mindflowLogin.1f108f97.png";